import actions from './actions';
import initialState from '../initialState';

export const drawReducer = (state = initialState.drawState, action) => {
    switch (action.type) {
        case actions.SET_TOGGLE_ARRAY:
            return { ...state, toggleArray: action.state.toggleArray };
        case actions.SET_DRAW_TOTAL:
            return { ...state, drawTotal: action.state.drawTotal };
        default:
            return state;
    }
};

export default drawReducer;
